import { FaTimes } from "react-icons/fa";
import React, { useState, useEffect } from 'react';
const TextModal = ({ isOpen, onClose, selected}) => {
    const [messages, setMessages] = useState([]);

    const currentDomain = () => {
        //if location origin starts with localhost, return localhost:3001
        if (location.origin.startsWith('http://localhost')) {
            return 'http://localhost:3001';
        } else {
            return location.origin;
        }
    }
    const fetchMessages = async () => {
        const response = await fetch(`${currentDomain()}/api/text/getMessages`);
        const data = await response.json();
        let acc = [];
        data.forEach(msg => {
            acc.push({
                id: msg.id,
                friendlyName: msg.name,
                body: msg.message
            });
        });
        setMessages(acc);
    };

    const sendTextMessage = async (message) => {
        console.log("Fetching messages");
        const response = await fetch(`${currentDomain()}/api/text/send/${message.id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            //selectedEntries "[{\"car_number\":376,\"year\":1969,\"make\":\"Ford\",\"model\":\"Bronco\",\"class_name\":\"C6\",\"owner_first_name\":\"Kyler\",\"owner_last_name\":\"Murray\",\"engine\":\"Engine\",\"club\":null,\"ispaid\":false,\"vtype\":1,\"features\":null,\"owner_email\":\"test@gmail.com\",\"owner_phone\":\"9137337776\",\"class_id\":\"99c269e9-3597-4fc5-9943-30b58d37a0d6\",\"owner_id\":\"d2d441b2-55ff-4886-85f0-f84a0a5707ad\",\"car_id\":\"46f3db6e-7068-41b0-9bd6-f04f16a52d99\",\"car_uuid\":null,\"avg_score\":null,\"ballots\":null,\"class_priority\":6,\"checkedin\":false,\"parking_zone\":null},{\"car_number\":374,\"year\":2018,\"make\":\"Toyota\",\"model\":\"Tundra\",\"class_name\":\"C11\",\"owner_first_name\":\"Brady\",\"owner_last_name\":\"Holland\",\"engine\":\"Engine\",\"club\":null,\"ispaid\":false,\"vtype\":2,\"features\":null,\"owner_email\":\"test@gmail.com\",\"owner_phone\":\"9137048131\",\"class_id\":\"89f15de3-fb5e-49af-8296-b3f437143bd4\",\"owner_id\":\"c12c1ab6-d9e8-4a1f-ab24-8fd28dfb3b8a\",\"car_id\":\"63878875-d7d8-4e68-ac37-d64236f35839\",\"car_uuid\":null,\"avg_score\":null,\"ballots\":null,\"class_priority\":11,\"checkedin\":false,\"parking_zone\":null}]"
            body: JSON.stringify(selected),
        });
    };

    useEffect(() => {
        if (isOpen) {
            fetchMessages();
        }
    }, [isOpen]);

    return (
        isOpen && (
            <div className="fixed inset-0 flex items-center justify-center z-50">
                {/* Background Overlay */}
                <div className="fixed inset-0 bg-black opacity-50"></div>

                {/* Modal Content */}
                <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-xl w-full max-h-[80vh] overflow-y-auto">

                    {/* Modal Header */}
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-bold">
                            Text Messages
                        </h2>
                        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                            <FaTimes />
                        </button>

                    </div>

                    {/* Modal Body */}
                    <div className="mb-4">
                        <h3 className="text-lg font-semibold mb-2">Text Messaging Feature</h3>
                        <div className="space-y-2">
                            {messages.map((message) => (
                                <div
                                    key={message.id}
                                    className="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 cursor-pointer transition-colors"
                                    onClick={() => {
                                        sendTextMessage(message);
                                    }}
                                >
                                    <p className="font-medium text-gray-900">{message.friendlyName}</p>
                                    <p className="text-gray-600 text-sm mt-1">{message.body}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    );
}


export default TextModal;